import "../index.css";
import { getSender, getSenderFull } from "../config/ChatLogics";
import {useEffect, useState} from "react";
import axios from "axios";
import ProfileModal from "./Modals/ProfileModal";
import ScrollableChat from "./ScrollableChat";
import animationData from "./../utils/animations/typing.json";
import socket from "./../socketClient";
import UpdateGroupChatModal from "./Modals/UpdateGroupChatModal";
import { ChatState } from "../Context/ChatProvider";
import Arrowlefticon from "../images/Arrowlefticon";
import notificationSound2 from "../utils/blow4.wav";
import notificationSound3 from "../utils/blow3.wav";
import MessagesInputs from "./MessagesInputs";
import {getAuthConfig, getCsrfToken} from "../utils/functions";
import SpinnerCustom from "./SpinnerCustom";
import { Alphabet, MAX_MESSAGE_LENGTH } from "./../utils/constants";

const SingleChat = ({ fetchAgain, setFetchAgain }) => {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [newMessage, setNewMessage] = useState("");
    const [socketConnected, setSocketConnected] = useState(false);
    const [typing, setTyping] = useState(false);
    const [istyping, setIsTyping] = useState(false);
    const [selectedChatCompare, setSelectedChatCompare] = useState();
    const [fileName, setFileName] = useState(' ');
    let [codedMessage, setCodedMessage] = useState(" ");
    let [decodedMessage, setDecodedMessage] = useState(" ");
    let [codedSrcImage, setCodedSrcImage] = useState(" ");
    const [additionalToken, setAdditionalToken] = useState("");
    const [picLoading, setPicLoading ] = useState(false);
    const [scrollTopBeforeDeleteSingleChat, setScrollTopBeforeDeleteSingleChat] = useState(0);
    const [secretCode, setSecretCode] = useState("");
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };
    const { selectedChat, setSelectedChat, user, notification, setNotification, openAvatar, encryption, setEncryption, writeRead, toggleWriteRead, setModal, modal, showToast, sounds, isOffline } =
        ChatState();
    const fetchMessages = async () => {
        if (!selectedChat) return;
        const config = {
            ...getAuthConfig(user.token),
            headers: {
                ...getAuthConfig(user.token).headers,
                'Cache-Control': 'no-store, no-cache, must-revalidate',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        };
        try {
            setLoading(true);
            setMessages([]);
            const { data } = await axios.get(
                // `${process.env.REACT_APP_API_URL}/api/message/${selectedChat._id}`,
                `${process.env.REACT_APP_API_URL}/api/message/${selectedChat._id}?nocache=${new Date().getTime()}`,
                config
            );
            setMessages(data);
            socket.emit("join chat", selectedChat._id);
        } catch (error) {
            console.error("💥 [AXIOS] ERROR:", error.response?.status || error.message);
            setMessages([]);
            if (!navigator.onLine) {
                showToast('warning', 'Offline mode: data for this chat is not cached.');
            } else {
                showToast('danger', 'Error occurred while fetching messages');
            }
        } finally {
            setLoading(false); 
        }
    };

    const sendMessage = async (event) => {
        if ((event.key === "Enter" || event === "animationClick") && newMessage) {
            if(secretCode.length < 9 && secretCode !== "") {
                showToast('warning', 'Secret key is too short. Please enter a longer secret key.');
                return;
            }
            socket.emit("stop typing", selectedChat._id);
            if(!codedMessage && writeRead === true) {
                showToast('warning', 'No message to send.');
                return;
            }
            if (isOffline) {
                showToast ( 'warning', 'You are offline. Check the connection.' );
            }
            try {
                if (writeRead === false) {
                    onClickSpanFunction();
                    showToast (
                        'warning', 'Set the switch to the position WRITE'
                    )
                    return
                }
                const lastMessageTime = selectedChat.latestMessage ? Date.parse(selectedChat.latestMessage.createdAt) : 0; 
                if (Date.now() - lastMessageTime < 3100) {
                    showToast('danger', 'Too many requests in a short time. Please slow down.'); // Too many requests
                    return;
                }
                const tokenFromCookie = getCsrfToken();
                const config = {
                    headers: { "Content-type": "application/json", Authorization: `Bearer ${user.token}`, "X-XSRF-TOKEN": tokenFromCookie },
                    withCredentials: true  
                }; 
                setNewMessage("");
                const messageAPI = (!fileName || fileName===' ') ? `${process.env.REACT_APP_API_URL}/api/message` : `${process.env.REACT_APP_API_URL}/api/message/upload`;
                const { data } = await axios.post(
                    messageAPI,
                    {
                        content: codedMessage,
                        chatId: selectedChat._id,
                        pic: codedSrcImage,
                        additionalToken
                    },
                    config
                );

                socket.emit("new message", data);
                if(sounds) {
                    const sound = new Audio(notificationSound2);
                    sound.play();
                }
                setMessages([...messages, data]);
                setFileName(' ');
            } catch (error) {
                setFileName('');
                if (error.response && error.response.status === 429) {
                    console.log("429 error caught in sended messages", error.response)  ;
                    showToast('danger', error.response.data.message); 
                } else {
                    showToast ( 'danger', 'Error oqured. Relogin' )
                }
            }
        }
    };

    useEffect(() => {
        socket.emit("setup", user);
        socket.on("connected", () => setSocketConnected(true));
        socket.on("typing", () => setIsTyping(true));
        socket.on("stop typing", () => setIsTyping(false));
        const stored = localStorage.getItem(PICTURE_TIME_STAMPS);
        if (stored) {
            setUploadTimestamps(JSON.parse(stored));
        }
    }, []);

    useEffect(() => {
        fetchMessages();
        setSelectedChatCompare(selectedChat); // Renew the state for comparison
    }, [selectedChat]);



// Resolving empty chans while sand message
    // useEffect(() => {
    //     const handleMessageRecieved = (newMessageRecieved) => {
    //         try {
    //             if (
    //                 !selectedChatCompare ||
    //                 selectedChatCompare._id !== newMessageRecieved.chat._id
    //             ) {
    //                 if (!notification.includes(newMessageRecieved)) {
    //                     setNotification([newMessageRecieved, ...notification]);
    //                     setFetchAgain(!fetchAgain);
    //                 } else {
    //                     console.log("Message already in notification");
    //                 }
    //             } else {
    //                 setMessages([...messages, newMessageRecieved]);
    //                 if(sounds) {
    //                     const sound = new Audio(notificationSound3);
    //                     sound.play();
    //                 }
    //             }
    //         } catch (error) {
    //             console.error("Error in handleMessageRecieved:", error);
    //         }
    //     };

    //     socket.on("message recieved", handleMessageRecieved);
    //     return () => {
    //         socket.off("message recieved", handleMessageRecieved);
    //     };
    // }, [socket, messages, notification, selectedChatCompare, setMessages, setNotification, setFetchAgain]);
    useEffect(() => {
        const handleMessageRecieved = (newMessageRecieved) => {
            // Ми використовуємо значення selectedChatCompare з замикання (closure)
            // або через ref, якщо воно часто змінюється.
            if (!selectedChatCompare || selectedChatCompare._id !== newMessageRecieved.chat._id) {
                
                // Оновлюємо стан БЕЗ прив'язки до попереднього значення в списку залежностей
                setNotification((prev) => {
                    if (!prev.includes(newMessageRecieved)) {
                        return [newMessageRecieved, ...prev];
                    }
                    return prev;
                });
                
                setFetchAgain((prev) => !prev); // Оновлюємо список чатів
            } else {
                // Оновлюємо повідомлення в поточному чаті
                setMessages((prev) => [...prev, newMessageRecieved]);
                
                if (sounds) {
                    const sound = new Audio(notificationSound3);
                    sound.play();
                }
            }
        };

        socket.on("message recieved", handleMessageRecieved);

        return () => {
            socket.off("message recieved", handleMessageRecieved);
        };
    }, [socket, selectedChatCompare]); // Now minimum here
// Resolving empty chans while sand message





    useEffect(() => {
        socket.on("connect", () => {
            setSocketConnected(true);
            socket.emit("setup", user);
        });
        socket.on("connected", () => setSocketConnected(true));
        socket.on("typing", () => setIsTyping(true));
        socket.on("stop typing", () => setIsTyping(false));
        return () => {
            socket.off("connect");
        };
    }, []);

    useEffect(() => {
        if (selectedChat) {
            socket.emit("join chat", selectedChat._id);
        }
        setScrollTopBeforeDeleteSingleChat(null);
    }, [selectedChat]);

    const typingHandler = (e) => {
        const newValue = (typeof e === 'string' ? e : e.target.value);
        if (newValue.match(/[<>&]/) && writeRead === true) {
            showToast('warning', 'Please avoid using <, >, & characters.');
            const sanitizedValue = newValue.replace(/[<>&]/g, '').slice(0, MAX_MESSAGE_LENGTH);
            setNewMessage(sanitizedValue);
            return;
        }
        if (newValue.length > MAX_MESSAGE_LENGTH && writeRead === true) {
            showToast('warning', 'Please do not use such a long secret word.');
            const cutValue = newValue.slice(0, MAX_MESSAGE_LENGTH);
            setNewMessage(cutValue);
        } else {
            setNewMessage(newValue);
        }

        if (!socketConnected) return;

        if (!typing) {
            setTyping(true);
            socket.emit("typing", selectedChat._id);
        }
        let lastTypingTime = new Date().getTime();
        var timerLength = 3000;
        setTimeout(() => {
            var timeNow = new Date().getTime();
            var timeDiff = timeNow - lastTypingTime;
            if (timeDiff >= timerLength && typing) {
                socket.emit("stop typing", selectedChat._id);
                setTyping(false);
            }
        }, timerLength);
    };
    const MAX_REQUESTS = 3; // Max 3 pictures
    const TIME_WINDOW_MS = 86400000; //  day
    const [uploadTimestamps, setUploadTimestamps] = useState([]);
    const PICTURE_TIME_STAMPS = 'uploadTimestamps';
    const handleFileChange = (pics) => {
        if (!pics) {
            showToast('warning', 'Picture is absent. Please select an image.');
            setPicLoading(false);
            return;
        }
        setPicLoading(true);
      
        const storedTimestamps = JSON.parse(localStorage.getItem(PICTURE_TIME_STAMPS)) || [];
        const now = Date.now();
        const recentUploads = storedTimestamps.filter(time => now - time < TIME_WINDOW_MS);
        // Change to right. Also in  Imageuploadwiddleware   delete 10
          if (recentUploads.length >= 177) {
        // if (recentUploads.length >= MAX_REQUESTS) {
            showToast('warning',  `Only  (${MAX_REQUESTS} pictures per day are allowed).`);
            setFileName('')
            setPicLoading(false);
            return;
        }
        const MAX_SIZE = 2097152; 
        const isAllowedType = pics.type === "image/jpeg" || pics.type === "image/jpg" || pics.type === "image/png";
        
        if (!isAllowedType || pics.size > MAX_SIZE) {
            showToast('danger',  `Please select a JPEG/PNG image file smaller than ${MAX_SIZE / 1048576}MB.`);
            setPicLoading(false);
            setFileName('');
            return;
        }
        const data = new FormData();
        data.append("file", pics);
        data.append("upload_preset", "chat-app"); 
        fetch("https://api.cloudinary.com/v1_1/dvxtzwyam/image/upload", {
            method: "post",
            body: data
        })
        .then(res => res.json())
        .then(result => {
            if (result.secure_url) {
                const newTimestamps = [...recentUploads, Date.now()];
                localStorage.setItem(PICTURE_TIME_STAMPS, JSON.stringify(newTimestamps));
                setUploadTimestamps(newTimestamps);
                setFileName(result.secure_url);
                showToast('success', 'Image uploaded successfully!');
            } else {
                throw new Error(result.error ? result.error.message : "Cloudinary upload failed.");
            }
        })
        .catch(err => {
            console.error("Upload Error:", err);
            showToast('danger', `Image upload failed: ${err.message || "Unknown error"}`);
            setFileName('');
        })
        .finally(() => {
            setPicLoading(false);
        });
    };

    useEffect(() => {
        if (fileName && fileName !== ' ') {
            const text = fileName;
            const partAfter = fileName.split("image/upload/")[1];
            const partBefore = fileName.split("image/upload/")[0];
            const numAlph = {};
            for(let i=0; i<Alphabet.length; i++) {
                numAlph[Alphabet[i]] = i;
            }
            let codedMessage = "";
            const secretCodeForImage = secretCode.replace(/ /g, '_');
            for(let i=0; i<partAfter.length; i++) {
                codedMessage += Alphabet[(numAlph[partAfter[i]] + numAlph[secretCodeForImage[i % secretCodeForImage.length]]) % Alphabet.length];
            }
            codedMessage =  secretCode !== "" ? partBefore + "image/upload/" + codedMessage + ".jpg" : fileName;
            setCodedSrcImage(codedMessage);
        } else {
            setCodedSrcImage(fileName);
        }    
    }, [fileName, secretCode]);
    
    const deleteMessageHandler = async(userId, messageId)=> {
        const config = {
            headers: { Authorization: `Bearer ${user.token}` }
        };
        setLoading(true);
        handleSaveScrollTop(scrollTopBeforeDeleteSingleChat || 0); 
        try {
            await axios.post(
                `${process.env.REACT_APP_API_URL}/api/message/deleteMessage`,
                {
                    userId: userId,
                    messageId:  messageId,
                    chatId: selectedChat._id
                },
                config
            );
            setLoading(false);
            fetchMessages(selectedChat._id); 
            showToast ('success', 'Message successfull deleted!' );
        } catch (error) {
            setLoading(false);
            showToast ( 'danger', 'Error occured while deleting message' );
        }
    }
    const onClickSpanFunction =()=> {
        setModal({ ...modal, view: "query"});
    }

    const handleSaveScrollTop = (scrollTop) => { //For positioning messages after deleting a message
        setScrollTopBeforeDeleteSingleChat(scrollTop);
    };
    const handleClearScrollTop = () => {
        setScrollTopBeforeDeleteSingleChat(null);
    };
    const toggleWriteReadWithReset = () => {
        toggleWriteRead(!writeRead);
        setNewMessage("");
    }

    return (
        <>
            {selectedChat ? (
                <>
                    <div className='single_chat'>
                        <div className='single_chat_header1'>
                            <button type='button' className='icon_arrow icon_button' onClick={() => setSelectedChat("")} >
                                <Arrowlefticon className = 'icon' focusable="false" aria-hidden="true" />
                            </button>
                            { encryption ?  <div className='read_write_button'>
                                                <span className={`write_read_span1 ${writeRead ? 'writePassive ' : ' writeActive'}`}>READ </span>
                                                <label className='switch'>
                                                    <input type = 'checkbox' className='switch-input' checked={writeRead} onChange = {()=>toggleWriteReadWithReset()}/>
                                                    <span className={`switch-slider ${writeRead ? ' writeActive' : 'writePassive '}`}></span>
                                                </label>
                                                <span className={`write_read_span1 read ${writeRead ? ' writeActive' : 'writePassive '}`}>WRITE</span>
                                            </div>
                                         :  <div className='read_write_button'>
                                                <button onClick={()=>setEncryption(true)}><span className='write_read_span1' >Encryption is disabled </span> </button >
                                            </div> }
                        </div>
                        <div className='single_chat_header2'>
                            { messages && // !openAvatar &&     When Avatar (Redistrierter User) is on - man must not open
                                (!selectedChat.isGroupChat ? (
                                    <>
                                        <span>{getSender(user, selectedChat.users)}</span>
                                        { !openAvatar &&  <ProfileModal className='SingleChat ProfileModal'
                                            user={getSenderFull(user, selectedChat.users)}
                                        />}
                                    </>
                                ) : (
                                    <>
                                        <span>{selectedChat.chatName.toUpperCase()} </span>
                                        { !openAvatar &&  <UpdateGroupChatModal   className='SingleChat UpdateGroupChatModal'
                                            fetchMessages={fetchMessages}
                                            fetchAgain={fetchAgain}
                                            setFetchAgain={setFetchAgain}
                                        />}
                                    </>
                                ))}
                        </div>
                    </div>
                    <div className ='single_chat-field'>
                        {loading ? (
                            <SpinnerCustom />
                        ) : (
                            <div className="messages">
                                <ScrollableChat messages={messages} deleteMessageHandler={deleteMessageHandler} onSaveScrollTop={handleSaveScrollTop} onClearScrollTop={handleClearScrollTop}  scrollTopBeforeDeleteSingleChat={scrollTopBeforeDeleteSingleChat} secretCode={secretCode} newMessage={newMessage}/>
                            </div>
                        )}

                        <div className='form-control' onKeyDown={sendMessage}  id="first-name">
                            <MessagesInputs sendMessage={sendMessage} istyping={istyping} defaultOptions={defaultOptions} newMessage={newMessage} typingHandler={typingHandler} picLoading={picLoading} handleFileChange={handleFileChange} codedMessage={codedMessage} setCodedMessage={setCodedMessage} decodedMessage={decodedMessage} setDecodedMessage={setDecodedMessage} showToast={showToast} userToken={user._id.slice(0, 10)} setAdditionalToken={setAdditionalToken} secretCode={secretCode} setSecretCode={setSecretCode}/>
                            <div className=' input_picture'>
                                {picLoading
                                    ? <SpinnerCustom />
                                    :   <span>
                                            { fileName === ' ' ? <input type='file' onChange={(e) => handleFileChange(e.target.files[0])} key={messages.length} />
                                            : <span>{fileName.split('/').pop()}</span>}
                                        </span> }
                            </div>
                        </div>
                    </div>
                </>
            ): (
                // to get socket.io on same page
                <div className='box'>
                    <p className='text' >
                        Click on a user to start chatting
                    </p>
                </div>
            )}
        </>
    )
}
export default SingleChat